import { render, staticRenderFns } from "./AnnualCatalog.vue?vue&type=template&id=dc29a71e"
import script from "./AnnualCatalog.vue?vue&type=script&lang=js"
export * from "./AnnualCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports